

import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom"
import { PrivateSectionLayout } from "../../pages/private-section/private-section-layout/PrivateSectionLayout"
import { DossieSearchPage } from "../../pages/private-section/dossie-search/DossieSearchPage"
import { DossieResultsPage } from "../../pages/private-section/dossie-results/DossieResultsPage"
import { ComplianceAlertContainer } from "../../compliance-alert"
import { CobrancaAlertContainer } from "../../cobranca-alert"

import { PrivateRoute } from "../private-route"
import { AuthSyncPage } from "../../pages/auth-section/AuthSyncPage"


export const MainRouter = () => {
  return (
    <>
      <BrowserRouter>
        <ComplianceAlertContainer />
        <CobrancaAlertContainer />
        <Routes>
          <Route path="/" element={<Navigate to="/private/dossie/search" replace />} />
          <Route path="auth/login" element={<AuthSyncPage />} />
          <Route path="auth/sync" element={<AuthSyncPage />} />
          <Route path="private" element={<PrivateSectionLayout />}>
            <Route path="" element={<Navigate to="dossie/search" replace />} />
            <Route path="dossie/search" element={
              <PrivateRoute>
                <DossieSearchPage />
              </PrivateRoute>
            } />
            <Route path="dossie/results/:documento" element={
              <PrivateRoute>
                <DossieResultsPage />
              </PrivateRoute>
            } />
          </Route>
        </Routes>
      </BrowserRouter>
    </>

  )
}